import { toString } from "lodash";

let confirm: any;

export const setNotifyConfirm = (confirmFn: any) => {
  confirm = confirmFn;
};

export const notify = (message) => {
  return new Promise((resolve, reject) => {
    const confirmed = confirm(toString(message));
    if (confirmed){
      resolve(true);
    } else {
      reject(false);
    }
  });
};


// WEBPACK FOOTER //
// ./src/shared/services/notify.ts